import { Component } from '@angular/core'

@Component({
  selector: 'app-market',
  templateUrl: './market.component.html',
  standalone: false
})
export class MarketComponent {}
